import { ModuleWithProviders, NgModule, APP_INITIALIZER, Injectable } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UserIdleModule } from 'angular-user-idle';
import { MatTreeModule } from '@angular/material/tree';
import { MatRadioModule } from '@angular/material/radio'
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HttpErrorResponse, HttpClientXsrfModule, HttpInterceptor, HttpXsrfTokenExtractor, HttpRequest, HttpHandler, HttpEvent, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpModule }      from '@angular/http';
import { Observable, of, throwError } from 'rxjs';
import { FileUploadModule } from 'ng2-file-upload';

import { AppComponent } from './app.component';
import { HomeModule } from './HomeComponent/home.module';
import { AppRoutingModule } from './app-routing.module';
import { AuthGuard, AuthenticationService } from './auth/index';

import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { Globals } from './globals';

/** Components */
import { LoginComponent } from './LoginComponent/login.component';
import { EmployerFormComponent } from './EmployerComponent/EmployerFormComponent/employer.form.component';
import { NewRegisterFormComponent } from './RegisterComponent/NewRegisterFormComponent/new.register.form.component';
import { NewRegisterViewComponent } from './RegisterComponent/NewRegisterViewComponent/new.register.view.component';
import { EmployerViewComponent } from './EmployerComponent/EmployerViewComponent/employer.view.component';
import { ProjectViewComponent } from './ProjectComponent/ProjectViewComponent/project.view.component';
import { ProjectFormComponent } from './ProjectComponent/ProjectFormComponent/project.form.component';
import { NewProjectViewComponent } from './ProjectComponent/NewProjectViewComponent/new.project.view.component';
import { NewProjectFormComponent } from './ProjectComponent/NewProjectFormComponent/new.project.form.component';
import { RegisterViewComponent } from './RegisterComponent/RegisterViewComponent/register.view.component';
import { RegisterFormComponent } from './RegisterComponent/RegisterFormComponent/register.form.component';
import { ExportImportComponent } from './ExportImportComponent/exportimport.component';
import { ListComponent } from './ListComponent/list.component';
import { ReportComponent } from './ReportComponent/ReportComponent/report.component';
import { NewReportComponent } from './ReportComponent/NewReportComponent/new.report.component';
import { NotificationComponent } from './NotificationComponent/notification.component';
import { ErrorComponent } from './shared/views/ErrorComponent/error.component';
import { StatisticComponent } from './StatisticComponent/statistic.component';
import { SearchComponent } from './shared/views/SearchComponent/search.component';
import { AdministrationComponent } from './AdministrationComponent/administration.component';

import { EmployerPipe } from './directives/employer.pipe';
import { GroupPipe } from './directives/group.pipe';
import { ProjectPipe } from './directives/project.pipe';
import { OrderrByPipe } from './directives/orderby.pipe';
import { SortByDatePipe } from './directives/sortbydate.pipe';
import { FooterComponent, HeaderComponent, ConfirmComponent, SharedModule, SidebarComponent, LoaderComponent } from './shared';
import { PersonViewComponent } from './PersonComponent/PersonViewComponent/person.view.component';
import { PersonFormComponent } from './PersonComponent/PersonFormComponent/person.form.component';
import { NotesComponent } from './shared/views/NotesComponent/notes.component';
import { DepartmentTreeComponent } from './shared/views/DepartmentTreeComponent/department.tree.component';
import { ValidationModalComponent } from './shared/views/ValidationModalComponent/validation.modal.component';
import { ArchiveModalComponent } from './shared/views/ArchiveModalComponent/archive.modal.component';
import { HierarchyModalComponent } from './shared/views/HierarchyModalComponent/hierarchy.modal.component';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { DateAdapter, MatDatepickerModule, MatNativeDateModule, MatFormFieldModule, MatInputModule, MatIconModule, MatProgressBarModule, MatAutocomplete, MatAutocompleteModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS} from '@angular/material';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { MatMomentDateModule, MAT_MOMENT_DATE_FORMATS, MAT_MOMENT_DATE_ADAPTER_OPTIONS,MomentDateAdapter } from '@angular/material-moment-adapter';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DepartmentTreeService } from './shared/views/DepartmentTreeComponent/department.tree.service';
import { AppConfig } from './app.config';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { ImportRKImage } from './ImportRKImage/importrkimage.component';
import { SecurityAgreementFormComponent } from './SecurityAgreementComponent/SecurityAgreementFormComponent/security.agreement.form.component';
import { SecurityAgreementViewComponent } from './SecurityAgreementComponent/SecurityAgreementViewComponent/security.agreement.view.component';
import { DebriefingSAPOComponent } from './DebriefingSAPOComponent/debriefingsapo.component';
import { ErrorModalComponent } from './shared/views/ErrorModalComponent/error.modal.component';
import { ConflictHandlerModalComponent } from './shared/views/ConflictHandlerModalComponent/conflict.handler.modal.component'
import { ConflictComponent } from './shared/views/ConflictHandlerModalComponent/ConflictComponent/conflict.component';
import { SearchDropdownComponent } from './shared/input/SearchableDropdown/search.dropdown.component';
import { ConfirmModalComponent } from './shared/views/ConfirmModalComponent/confirm.modal.component';
import { ProjectRadioTreeComponent } from './ProjectComponent/NewProjectFormComponent/ProjectRadioTreeComponent/project.radio.tree.component';
import { ProjectTreeModalComponent } from './ProjectComponent/NewProjectViewComponent/ProjectTreeModalComponent/project.tree.modal.component';

import { MomentUtcDateAdapter } from './models/moment-utc-date-adapter';
import { BlobErrorHttpInterceptor } from './HttpInterceptor/BlobErrorHttpInterceptor';

import { getTimeoutSettings } from './models/app-config-functions';
import { TextareaAutoresizeDirective } from './directives/textarea-autoresize.directive';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

const rootRouting: ModuleWithProviders = RouterModule.forRoot([], { useHash: false });

@Injectable()
export class HttpXsrfInterceptor implements HttpInterceptor {
  constructor(private tokenExtractor: HttpXsrfTokenExtractor, private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headerName = 'X-XSRF-TOKEN';
    let token = this.tokenExtractor.getToken() as string;
    
    if (token !== null && !req.headers.has(headerName)) {
      req = req.clone({ headers: req.headers.set(headerName, token) });
    }
    return next.handle(req).pipe(catchError(err => {
        if(err.status === 401) {
            this.router.navigate(['/login']);
        }
        const error = err.error.message || err.statusText;
        return throwError(error);
        }
    ));
  }
}

@NgModule({
    declarations: [
        AppComponent,  
        FooterComponent,
        HeaderComponent,   
        ConfirmComponent,
        SidebarComponent, 
        ErrorComponent,
        LoaderComponent,
        LoginComponent,   
        RegisterViewComponent, 
        RegisterFormComponent,
        NewRegisterFormComponent,
        NewRegisterViewComponent,
        NewProjectViewComponent,
        NewProjectFormComponent,
        ExportImportComponent,
        PersonViewComponent,
        PersonFormComponent,
        EmployerFormComponent,
        EmployerViewComponent,
        NotificationComponent,
        ProjectViewComponent,
        ProjectFormComponent,
        SecurityAgreementFormComponent,
        SecurityAgreementViewComponent,
        ImportRKImage,
        ListComponent,
        NotesComponent,
        DepartmentTreeComponent,
        ValidationModalComponent,
        ArchiveModalComponent,
        StatisticComponent,
        ReportComponent,
        NewReportComponent,
        SearchComponent,
        EmployerPipe,
        GroupPipe,
        ProjectPipe,
        OrderrByPipe,
        SortByDatePipe,
        DebriefingSAPOComponent,
        ErrorModalComponent,
        ConflictHandlerModalComponent,
        ConflictComponent,
        SearchDropdownComponent,
        ConflictComponent,
        HierarchyModalComponent,
        ConfirmModalComponent,
        ProjectRadioTreeComponent,
        ProjectTreeModalComponent,
        AdministrationComponent,
        TextareaAutoresizeDirective
    ],
    imports: [
        BrowserModule,
        MatTreeModule,
        CdkTreeModule,
        MatIconModule,
        HttpModule,
        MatProgressBarModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatInputModule,
        MatListModule,
        FileUploadModule,
        MatFormFieldModule,
        BrowserAnimationsModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'XSRF-TOKEN',
            headerName: 'X-CSRF-Token',
        }),
        MatDatepickerModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatSelectModule,
        MatRadioModule,
        HttpClientModule,
        AngularFontAwesomeModule,
        BsDropdownModule.forRoot(),
        TooltipModule.forRoot(),
        ModalModule.forRoot(),
        NgxSmartModalModule.forRoot(),
        AppRoutingModule,
        FormsModule,
        SharedModule,
        HomeModule,
        rootRouting,
        // Optionally you can set time for `idle`, `timeout` and `ping` in seconds.
        // Default values: `idle` is 540 (9 minutes), `timeout` is 30 (30 sek)
        // and `ping` is 240 (4 minutes).
        // for an hour idle: 3600 timeout: 30 ping: 240
        //UserIdleModule.forRoot({idle: 540, timeout: 30, ping: 240})
        UserIdleModule.forRoot(getTimeoutSettings()),
        PdfJsViewerModule,
        MatPaginatorModule
    ],    
    providers: [
        AppConfig,
        { provide: HTTP_INTERCEPTORS, useClass: HttpXsrfInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: BlobErrorHttpInterceptor, multi: true },
        { provide: APP_INITIALIZER, useFactory: (config: AppConfig) => () => config.load(), deps: [AppConfig], multi: true },
        { provide: MAT_DATE_LOCALE, useValue: 'sv-SE' },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        { provide: DateAdapter, useClass: MomentUtcDateAdapter },
        //{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        //{provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },        
        AuthGuard,
        Globals,
        AuthenticationService,
        DepartmentTreeService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }